import type { TenantFeature } from '@/core/types/features';
import { tenantFeatureCodes } from '@/core/types/features';
import { env } from '@/core/config/env';
import { httpClient } from './httpClient';

const demoFeatures: TenantFeature[] = Object.values(tenantFeatureCodes).map((code, sortOrder) => ({
  code,
  title: code,
  description: '',
  sortOrder,
  isEnabled: true,
  isOverridden: false,
}));

export const tenantFeaturesApi = {
  current: async (): Promise<TenantFeature[]> => {
    if (env.isDemo) return demoFeatures;
    return (await httpClient.get<TenantFeature[]>('/api/v1/tenant-workspace/features')).data;
  },
};
